import React, { useContext, useEffect } from 'react';
import { View } from 'dripsy';
import { useAtom } from 'jotai';
import ServiceList from '../../components/ServiceList';
import { localAtom } from '../../atoms';
import { LanguageContext } from '../../context/LanguageContext';
import { CIDADE } from '../../values/constants';
import { PraiasProps } from '../../navigation/types';

const Praias: React.FC<PraiasProps> = ({ navigation }) => {
  const [local] = useAtom(localAtom);
  const [{ strings: str }] = useContext(LanguageContext);

  useEffect(() => {
    navigation.setOptions({ headerTitle: `${CIDADE[local]} / ${str.praias}` });
  }, [navigation, local, str]);

  return (
    <View sx={{ flex: 1 }}>
      <ServiceList repo='Praias' />
    </View>
  );
};

export default Praias;
